import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { iif, Observable, of } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Item } from '../../../app/api/models/lookup-dto';
import { LookupService } from '../../../app/api/services';

@Component({
  selector: 'app-search-select',
  templateUrl: './search-select.component.html',
  styleUrls: ['./search-select.component.scss']
})
export class SearchSelectComponent implements OnInit, OnChanges {

  @Output() hasSelectOption = new EventEmitter();
  @Input() defaultValue: any;
  @Input() controlledInputValue: any;
  @Input() keyId!: string;
  @Input() hintText: string = '';
  @Input() readOnly: boolean = false;
  @Input() noBorder: boolean = false;
  @Input() invalid: boolean = false;

  searchForm = new FormGroup({
    query: new FormControl()
  });

  ngOnInit() {
    this.searchForm.valueChanges.subscribe(res => {
      if (typeof res.query === 'string') {
        let el = document.getElementById(this.keyId) as any;
        el.getElementsByClassName("mat-mdc-text-field-wrapper")[0].style.border = "none"
        this.hasSelectOption.emit('');
      }
    });
    if (this.defaultValue) {
      this.searchForm.get('query')?.setValue(this.defaultValue);
    }
  }

  // Get loading stream from service
  loading$: Observable<boolean> = this.lookupService.loading$;

  // Debounce for typing
  // then destructure form since we only need query
  // Then if it is a query longer than 3, send GET request
  searchResults$ = this.searchForm.valueChanges.pipe(
    debounceTime(100),
    switchMap(({ query }) =>
      iif(() => query && query.length > 3,
        this.lookupService.getUsers(query),
        of(null))
    )
  );

  ngOnChanges(changes: SimpleChanges): void {
    let controlledInputValue = changes["controlledInputValue"]?.currentValue;
    if (controlledInputValue === "") {
      this.searchForm.get('query')?.setValue(controlledInputValue);
    }
  }


  displayFn(eventObj: Item): string {
    this.hasSelectOption.emit(eventObj);
    if (!eventObj) {
      return ''
    };
    if (!this.noBorder) {
      let el = document.getElementById(this.keyId) as any;
      el.getElementsByClassName("mat-mdc-text-field-wrapper")[0].style.border = "1px solid black"
    }
    return eventObj.value || '';
  }

  constructor(private lookupService: LookupService) { }
}
